import { PLACEHOLDER } from "theme/config/constants";
import React, { useEffect, useRef, useState } from "react";
import { imgixSrc, stormSrc } from "core-web/libs/image";

// import Events from "core-web/libs/Events";
import Image from "core-web/components/Image";
import Link from "core-web/components/Link";
import Price from "theme/components/products/Price";
// import { ProductEvents } from "core-web/libs/Events/constants";
import PropTypes from "prop-types";
import TextStyles from "theme/components/text/TextStyles";
import hideOverlays from "core-web/state/models/Overlay/dispatches/hideOverlays";
import styled from "theme/libs/styled";
import toggleSearch from "core-web/state/models/Header/dispatches/toggleSearch";
import { useSelector } from "react-redux";
import { checkForLocalePrefix } from "core-web/utils/checkForLocalePrefix";

const Wrapper = styled("article")`
    position: relative;
    display: grid;
    grid-template-columns: 102px 1fr;
    height: auto;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 8px;
    transition: all ${({ theme }) => theme.transitions.primary};

    img {
        scale: 0.95;
        transition: scale 0.3s;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.neutral_50};

        img {
            scale: 1;
        }
    }
`;

const ContentWrapper = styled("div")`
    display: grid;
    grid-template-columns: 1fr;
    height: max-content;
    gap: 4px 8px;
    padding: 12px 8px 12px 12px;

    ${({ theme }) => theme.above.tabletLg} {
        padding: 12px 8px 12px 16px;
    }
`;

const ImageWrapper = styled("div")`
    display: flex;
    place-items: center;
    padding: 12px;
    height: 100%;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.neutral_50};
`;

const PackageProductCard = ({
    priceExVat,
    standardPriceExVat,
    price_inc_vat,
    price,

    vatRate,
    priceListCode,

    format,
    name,
    url,
    priceListId,
}) => {
    const ecommerceEnabled = useSelector(({ application }) => application.ecommerceEnabled);

    const wrapperRef = useRef(null);
    const wrapperHeight = wrapperRef?.current?.clientHeight;
    const [heightValue, setHeightValue] = useState(`${wrapperHeight}px`);

    // This useEffect is needed for a smooth first open-animation in SSR.
    useEffect(() => {
        setHeightValue(`${wrapperRef?.current?.clientHeight}px`);
    }, [wrapperRef]);

    // const tracking = () => {
    //     Events.trigger(ProductEvents.CLICK, {
    //         product: { categories, categoryPrimary, name, partNo, priceExVat },
    //     });
    // };

    const imageSrc = format?.image
        ? stormSrc(format.image, { m: "pad", f: "webp", w: 80, h: 80 })
        : imgixSrc(PLACEHOLDER, { fm: "avif", fit: "fill", fill: "solid", w: 80, h: 80 });

    const placeholder = format?.image
        ? stormSrc(format?.image, { m: "pad", f: "webp", q: 10, w: 80, h: 80 })
        : imageSrc;

    const handleNavigationClick = () => {
        toggleSearch(false);
        hideOverlays();

        // tracking();
    };

    const localPrefix = checkForLocalePrefix(url);
    const productSlug = url.replace(`${localPrefix}/`, "");

    return (
        <Link to={productSlug} onClick={handleNavigationClick}>
            <Wrapper ref={wrapperRef} height={heightValue}>
                <ImageWrapper aspectRatio={1}>
                    <Image
                        placeholder={placeholder}
                        alt={name}
                        title={name}
                        src={{
                            url: imageSrc,
                            width: [100, 100],
                        }}
                        mixBlendMode="multiply"
                        height="100%"
                    />
                </ImageWrapper>

                <ContentWrapper>
                    <TextStyles textStyles="Myriad Pro/16-120">{name}</TextStyles>

                    {ecommerceEnabled && (
                        <Price
                            price={price || price_inc_vat}
                            priceExVat={priceExVat}
                            standardPriceExVat={standardPriceExVat}
                            vatRate={vatRate}
                            priceListCode={priceListCode}
                            priceListId={priceListId}
                            textStyles="Myriad Pro/16-120"
                        />
                    )}
                </ContentWrapper>
            </Wrapper>
        </Link>
    );
};

PackageProductCard.propTypes = {
    categories: PropTypes.array.isRequired,
    categoryPrimary: PropTypes.string.isRequired,
    fromExVat: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    partNo: PropTypes.string.isRequired,
    priceExVat: PropTypes.number.isRequired,
    priceListCode: PropTypes.string,
    priceListId: PropTypes.number,
    standardFromExVat: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    vatRate: PropTypes.number.isRequired,
};

PackageProductCard.defaultProps = {
    priceListCode: null,
    priceListId: null,
};

export default PackageProductCard;
